import { useState, useEffect } from 'react';
import { 
  FiHeart, FiShare2, FiMaximize2, FiMapPin, 
  FiCalendar, FiHome, FiDollarSign,
  FiX, FiChevronRight, FiGrid, FiList
} from 'react-icons/fi';
import { GiSparkles, GiTennisRacket, GiFilmProjector } from 'react-icons/gi';
import { FaSchool, FaHospital, FaShoppingCart, FaRunning, FaSwimmer, FaDumbbell } from 'react-icons/fa';
import { MdApartment, MdBusinessCenter, MdLocationCity } from 'react-icons/md';

const Projects = () => {
  const [filter, setFilter] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const [likedProjects, setLikedProjects] = useState({});
  const [viewMode, setViewMode] = useState('grid');

  const projects = [
    {
      id: 1,
      name: 'Purvanchal Heights',
      location: 'Noida Extension',
      type: 'Luxury Apartments',
      category: 'residential',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&w=800&h=600&fit=crop',
      price: '₹1.2 Cr onwards',
      area: '2500 - 4500 sq.ft',
      bedrooms: '3, 4 & 5 BHK',
      completion: 'Dec 2025',
      features: ['Swimming Pool', 'Club House', 'Gym', 'Landscaped Gardens'],
      featureIcons: [FaSwimmer, GiSparkles, FaDumbbell, GiSparkles],
      highlight: 'Best Seller'
    },
    {
      id: 2,
      name: 'Global Towers',
      location: 'Greater Noida',
      type: 'Premium Residences',
      category: 'residential',
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&w=800&h=600&fit=crop',
      price: '₹2.5 Cr onwards',
      area: '3200 - 5500 sq.ft',
      bedrooms: '4 & 5 BHK',
      completion: 'Mar 2026',
      features: ['Infinity Pool', 'Spa', 'Tennis Court', 'Private Theater'],
      featureIcons: [FaSwimmer, GiSparkles, GiTennisRacket, GiFilmProjector],
      highlight: 'Luxury Redefined'
    },
    {
      id: 3,
      name: 'Ventures County',
      location: 'Lucknow',
      type: 'Integrated Township',
      category: 'township',
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&w=600&h=400&fit=crop',
      price: '₹85 Lacs onwards',
      area: '1500 - 3000 sq.ft',
      bedrooms: '2, 3 & 4 BHK',
      completion: 'Jun 2025',
      features: ['School', 'Hospital', 'Shopping Mall', 'Sports Complex'],
      featureIcons: [FaSchool, FaHospital, FaShoppingCart, FaRunning],
      highlight: 'Coming Soon'
    },
    {
      id: 4,
      name: 'Purvanchal Business Park',
      location: 'Noida',
      type: 'Commercial',
      category: 'commercial',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&w=800&h=600&fit=crop',
      price: '₹3.5 Cr onwards',
      area: '1000 - 5000 sq.ft',
      bedrooms: 'Commercial Space',
      completion: 'Aug 2025',
      features: ['LEED Certified', 'Smart Building', 'Food Court', 'Conference Halls'],
      featureIcons: [GiSparkles, MdApartment, FaShoppingCart, GiFilmProjector],
      highlight: 'Prime Location'
    },
    {
      id: 5,
      name: 'Riverside Estates',
      location: 'Varanasi',
      type: 'Waterfront Villas',
      category: 'residential',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&w=800&h=600&fit=crop',
      price: '₹1.8 Cr onwards',
      area: '4000 - 7000 sq.ft',
      bedrooms: '4, 5 & 6 BHK',
      completion: 'Feb 2026',
      features: ['Private Pool', 'Garden', 'Home Theater', 'Wine Cellar'],
      featureIcons: [FaSwimmer, GiSparkles, GiFilmProjector, GiSparkles],
      highlight: 'Limited Edition'
    },
    {
      id: 6,
      name: 'Tech Hub Commercial',
      location: 'Noida',
      type: 'IT Park',
      category: 'commercial',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&w=800&h=600&fit=crop',
      price: '₹4.5 Cr onwards',
      area: '2000 - 10000 sq.ft',
      bedrooms: 'Office Space',
      completion: 'Dec 2025',
      features: ['SEZ Zone', 'Data Center', 'Amphitheater', 'Food Plaza'],
      featureIcons: [MdBusinessCenter, MdApartment, FaShoppingCart, GiSparkles],
      highlight: 'Investment Hotspot'
    }
  ];

  const categories = [
    { id: 'all', label: 'All Projects', icon: MdLocationCity },
    { id: 'residential', label: 'Residential', icon: FiHome },
    { id: 'commercial', label: 'Commercial', icon: MdBusinessCenter },
    { id: 'township', label: 'Township', icon: MdApartment }
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.category === filter);

  const toggleLike = (id) => {
    setLikedProjects(prev => ({ ...prev, [id]: !prev[id] }));
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes projectsFadeUp {
        from { opacity: 0; transform: translateY(30px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes projectsScaleUp {
        from { opacity: 0; transform: scale(0.9); }
        to { opacity: 1; transform: scale(1); }
      }
      @keyframes projectsShimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      @keyframes projectsPulse {
        0%, 100% { opacity: 0.15; transform: scale(1); }
        50% { opacity: 0.3; transform: scale(1.05); }
      }
      .animate-projects-fade-up { animation: projectsFadeUp 0.8s ease-out forwards; }
      .animate-projects-scale-up { animation: projectsScaleUp 0.5s ease-out forwards; opacity: 0; }
      .animate-projects-shimmer {
        background: linear-gradient(90deg, #D4AF37, #FFD700, #D4AF37);
        background-size: 200% auto;
        -webkit-background-clip: text;
        background-clip: text;
        animation: projectsShimmer 3s linear infinite;
      }
      .animate-projects-pulse { animation: projectsPulse 4s ease-in-out infinite; }
      .delay-100 { animation-delay: 0.1s; }
      .delay-200 { animation-delay: 0.2s; }
      .delay-300 { animation-delay: 0.3s; }
      .delay-400 { animation-delay: 0.4s; }
      .font-serif { font-family: 'Cormorant Garamond', serif; }
      .font-montserrat { font-family: 'Montserrat', sans-serif; }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <section id="projects" className="relative py-16 sm:py-20 md:py-28 lg:py-32 overflow-hidden bg-navy">
      {/* Ambient Background - Matching Hero Section */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-navy via-navy/95 to-navy"></div>
        
        {/* Golden orb glows */}
        <div className="absolute top-20 right-20 w-[20rem] h-[20rem] sm:w-[30rem] sm:h-[30rem] md:w-[40rem] md:h-[40rem] bg-gold/5 rounded-full blur-3xl animate-projects-pulse"></div>
        <div className="absolute bottom-20 left-20 w-[18rem] h-[18rem] sm:w-[25rem] sm:h-[25rem] md:w-[35rem] md:h-[35rem] bg-amber-500/5 rounded-full blur-3xl animate-projects-pulse" style={{ animationDelay: '2s' }}></div>
        
        {/* Floating particles */}
        {[...Array(25)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-gold/20 rounded-full animate-projects-pulse"
            style={{
              width: `${Math.random() * 2 + 1}px`,
              height: `${Math.random() * 2 + 1}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${Math.random() * 10 + 8}s`,
            }}
          />
        ))}
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12 z-10">
        {/* Section Header - Matching Hero Typography */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20 animate-projects-fade-up">
          <div className="inline-flex items-center gap-2 sm:gap-3 mb-4 sm:mb-5">
            <div className="w-6 sm:w-8 h-px bg-gold"></div>
            <span className="text-gold text-[9px] sm:text-[10px] md:text-[11px] font-semibold tracking-[0.2em] sm:tracking-[0.24em] md:tracking-[0.28em] uppercase font-montserrat">Our Portfolio</span>
            <div className="w-6 sm:w-8 h-px bg-gold"></div>
          </div>
          
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-3 sm:mb-4">
            Signature
            <span className="block text-gold font-normal italic mt-1 sm:mt-2">Architectural Masterpieces</span>
          </h2>
          
          <div className="w-12 sm:w-16 h-px bg-gold/50 mx-auto mt-5 sm:mt-6 mb-5 sm:mb-6"></div>
          
          <p className="text-gray-300 max-w-2xl mx-auto text-xs sm:text-sm md:text-base leading-relaxed font-light px-4">
            Iconic developments that have redefined skylines across Purvanchal region, 
            setting new benchmarks in luxury living and commercial excellence.
          </p>
        </div>

        {/* Filter Buttons - Glassmorphic Style */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 mb-8 sm:mb-10 md:mb-12 animate-projects-fade-up delay-100">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setFilter(cat.id)}
              className={`group relative px-3 sm:px-4 md:px-6 py-1.5 sm:py-2 rounded-full transition-all duration-300 flex items-center gap-1.5 sm:gap-2 overflow-hidden text-xs sm:text-sm ${
                filter === cat.id 
                  ? 'bg-gold text-navy shadow-lg transform scale-105' 
                  : 'bg-black/30 backdrop-blur-sm text-gray-300 hover:bg-gold/20 border border-white/10'
              }`}
            >
              <cat.icon size={12} className="sm:text-sm" />
              <span className="relative z-10 tracking-wide">{cat.label}</span>
            </button>
          ))}
        </div>
        
        {/* Projects Grid */}
        <div className={`grid ${viewMode === 'grid' ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3' : 'grid-cols-1'} gap-5 sm:gap-6 md:gap-8`}>
          {filteredProjects.map((project, index) => (
            <div 
              key={project.id} 
              className="group animate-projects-scale-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="relative bg-black/30 backdrop-blur-md rounded-xl sm:rounded-2xl overflow-hidden border border-white/10 hover:border-gold/30 transition-all duration-500 hover:transform hover:-translate-y-2">
                {/* Image Container */}
                <div className="relative overflow-hidden h-48 sm:h-56 md:h-64 lg:h-72">
                  <img 
                    src={project.image} 
                    alt={project.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  {/* Type Badge */}
                  <div className="absolute top-3 left-3 sm:top-4 sm:left-4 bg-gold text-navy px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-[9px] sm:text-xs font-semibold shadow-lg z-10">
                    {project.type}
                  </div>
                  
                  {/* Highlight Badge */}
                  <div className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-black/60 backdrop-blur-sm text-gold px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-[8px] sm:text-[10px] font-semibold shadow-lg z-10 border border-gold/30">
                    {project.highlight}
                  </div>
                  
                  {/* Quick View Button */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
                    <button 
                      onClick={() => setSelectedProject(project)}
                      className="bg-gold text-navy px-4 sm:px-5 py-1.5 sm:py-2 rounded-full hover:bg-gold-dark transition-all duration-300 transform hover:scale-105 flex items-center gap-2 shadow-xl text-[10px] sm:text-xs font-semibold tracking-wide"
                    >
                      <FiMaximize2 size={12} />
                      Quick View
                    </button>
                  </div>
                </div>
                
                {/* Content */}
                <div className="p-4 sm:p-5 md:p-6">
                  <div className="flex justify-between items-start mb-2 sm:mb-3">
                    <h3 className="text-base sm:text-lg md:text-xl font-semibold text-white group-hover:text-gold transition-colors font-serif">
                      {project.name}
                    </h3>
                    <div className="flex gap-1 sm:gap-2">
                      <button 
                        onClick={() => toggleLike(project.id)}
                        className="text-gray-400 hover:text-red-500 transition-all duration-300 transform hover:scale-110"
                      >
                        <FiHeart 
                          size={14} 
                          className={`sm:text-base ${likedProjects[project.id] ? 'fill-red-500 text-red-500' : ''}`}
                        />
                      </button>
                      <button className="text-gray-400 hover:text-gold transition-all duration-300 transform hover:scale-110">
                        <FiShare2 size={14} className="sm:text-base" />
                      </button>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-1 text-gray-400 text-[10px] sm:text-xs mb-2 sm:mb-3">
                    <FiMapPin size={10} className="text-gold sm:text-xs" />
                    <span>{project.location}</span>
                  </div>
                  
                  <div className="flex items-baseline gap-0.5 mb-3 sm:mb-4">
                    {/* <FiDollarSign size={12} className="text-gold sm:text-sm" /> */}
                    <span className="text-gold font-bold text-sm sm:text-base md:text-lg">{project.price}</span>
                  </div>
                  
                  {/* Features Preview */}
                  <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-3 sm:mb-4">
                    {project.features.slice(0, 2).map((feature, idx) => (
                      <span key={idx} className="text-[9px] sm:text-[10px] bg-white/5 text-gray-300 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full">
                        {feature}
                      </span>
                    ))}
                    {project.features.length > 2 && (
                      <span className="text-[9px] sm:text-[10px] bg-white/5 text-gray-300 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full">
                        +{project.features.length - 2}
                      </span>
                    )}
                  </div>
                  
                  <div className="border-t border-white/10 pt-3 sm:pt-4 mt-2">
                    <div className="grid grid-cols-3 gap-1 sm:gap-2 text-center">
                      <div className="flex flex-col items-center">
                        <FiHome size={10} className="text-gold mb-0.5 sm:mb-1 sm:text-xs" />
                        <span className="text-gray-400 text-[8px] sm:text-[9px]">Area</span>
                        <span className="text-[10px] sm:text-xs font-semibold text-white">{project.area.split(' ')[0]}</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <FiHome size={10} className="text-gold mb-0.5 sm:mb-1 sm:text-xs" />
                        <span className="text-gray-400 text-[8px] sm:text-[9px]">Type</span>
                        <span className="text-[10px] sm:text-xs font-semibold text-white">{project.bedrooms.split(' ')[0]}</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <FiCalendar size={10} className="text-gold mb-0.5 sm:mb-1 sm:text-xs" />
                        <span className="text-gray-400 text-[8px] sm:text-[9px]">By</span>
                        <span className="text-[10px] sm:text-xs font-semibold text-white">{project.completion.split(' ')[1]}</span>
                      </div>
                    </div>
                  </div>
                  
                  <button className="w-full mt-4 sm:mt-5 bg-gold/10 border border-gold/30 text-gold py-1.5 sm:py-2 rounded-lg hover:bg-gold hover:text-navy transition-all duration-300 text-[10px] sm:text-xs font-semibold flex items-center justify-center gap-1 group">
                    <span>Enquire Now</span>
                    <FiChevronRight size={10} className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center mt-10 sm:mt-12 md:mt-16 animate-projects-fade-up delay-400">
          <button className="group relative px-6 sm:px-8 py-2 sm:py-3 rounded-full bg-transparent border border-gold text-gold hover:bg-gold hover:text-navy transition-all duration-300 transform hover:scale-105 font-semibold text-xs sm:text-sm overflow-hidden">
            <span className="relative z-10 flex items-center gap-2 tracking-wide">
              View All Projects
              <FiChevronRight size={12} className="group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
        </div>

        {/* Modal for Project Details - Matching Hero Style */}
        {selectedProject && (
          <div 
            className="fixed inset-0 bg-black/95 backdrop-blur-md z-50 flex items-center justify-center p-3 sm:p-4 animate-projects-fade-up"
            onClick={() => setSelectedProject(null)}
          >
            <div 
              className="bg-navy rounded-xl sm:rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-white/10"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative">
                <img 
                  src={selectedProject.image} 
                  alt={selectedProject.name} 
                  className="w-full h-48 sm:h-64 md:h-80 object-cover"
                />
                <button 
                  onClick={() => setSelectedProject(null)}
                  className="absolute top-3 right-3 sm:top-4 sm:right-4 bg-black/60 backdrop-blur-sm p-1.5 sm:p-2 rounded-full hover:bg-gold hover:text-navy transition-all duration-300 text-white"
                >
                  <FiX size={16} className="sm:text-xl" />
                </button>
                
                <div className="absolute bottom-3 left-3 sm:bottom-4 sm:left-4 flex gap-2">
                  <span className="bg-gold text-navy px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-[9px] sm:text-xs font-semibold">
                    {selectedProject.type}
                  </span>
                  <span className="bg-black/60 backdrop-blur-sm text-gold px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-[8px] sm:text-[10px] font-semibold border border-gold/30">
                    {selectedProject.highlight}
                  </span>
                </div>
              </div>
              
              <div className="p-5 sm:p-6 md:p-8">
                <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-6">
                  <div>
                    <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white mb-1 sm:mb-2 font-serif">{selectedProject.name}</h3>
                    <div className="flex items-center gap-2 text-gray-400 text-xs sm:text-sm">
                      <FiMapPin size={12} className="text-gold sm:text-sm" />
                      <span>{selectedProject.location}</span>
                    </div>
                  </div>
                  <div className="text-left sm:text-right">
                    <div className="text-gray-400 text-[10px] sm:text-xs">Price Range</div>
                    <div className="text-xl sm:text-2xl md:text-3xl font-bold text-gold">{selectedProject.price}</div>
                  </div>
                </div>
                
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
                  <div className="bg-black/30 backdrop-blur-sm p-3 sm:p-4 rounded-xl text-center border border-white/10">
                    <FiHome size={16} className="text-gold mx-auto mb-1 sm:mb-2 sm:text-xl" />
                    <div className="text-gray-400 text-[9px] sm:text-xs">Area</div>
                    <div className="font-semibold text-white text-[10px] sm:text-sm">{selectedProject.area}</div>
                  </div>
                  <div className="bg-black/30 backdrop-blur-sm p-3 sm:p-4 rounded-xl text-center border border-white/10">
                    <FiHome size={16} className="text-gold mx-auto mb-1 sm:mb-2 sm:text-xl" />
                    <div className="text-gray-400 text-[9px] sm:text-xs">Configuration</div>
                    <div className="font-semibold text-white text-[10px] sm:text-sm">{selectedProject.bedrooms}</div>
                  </div>
                  <div className="bg-black/30 backdrop-blur-sm p-3 sm:p-4 rounded-xl text-center border border-white/10">
                    <FiCalendar size={16} className="text-gold mx-auto mb-1 sm:mb-2 sm:text-xl" />
                    <div className="text-gray-400 text-[9px] sm:text-xs">Possession</div>
                    <div className="font-semibold text-white text-[10px] sm:text-sm">{selectedProject.completion}</div>
                  </div>
                  <div className="bg-black/30 backdrop-blur-sm p-3 sm:p-4 rounded-xl text-center border border-white/10">
                    <MdLocationCity size={16} className="text-gold mx-auto mb-1 sm:mb-2 sm:text-xl" />
                    <div className="text-gray-400 text-[9px] sm:text-xs">Status</div>
                    <div className="font-semibold text-green-400 text-[10px] sm:text-sm">Under Construction</div>
                  </div>
                </div>
                
                <h4 className="font-semibold text-white text-base sm:text-lg mb-3 sm:mb-4 flex items-center gap-2 font-serif">
                  <GiSparkles size={14} className="text-gold sm:text-lg" />
                  Key Features & Amenities
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 mb-6 sm:mb-8">
                  {selectedProject.features.map((feature, i) => {
                    const Icon = selectedProject.featureIcons?.[i] || GiSparkles;
                    return (
                      <div key={i} className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 bg-black/30 rounded-lg border border-white/10 hover:border-gold/30 transition-colors">
                        <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-gold/15 flex items-center justify-center">
                          <Icon size={12} className="text-gold sm:text-sm" />
                        </div>
                        <span className="text-gray-300 text-[10px] sm:text-xs">{feature}</span>
                      </div>
                    );
                  })}
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <button className="flex-1 bg-gold text-navy py-2.5 sm:py-3 rounded-xl hover:bg-gold-dark transition-all duration-300 font-semibold text-xs sm:text-sm tracking-wide">
                    Request a Site Visit
                  </button>
                  <button className="flex-1 border border-gold text-gold py-2.5 sm:py-3 rounded-xl hover:bg-gold hover:text-navy transition-all duration-300 font-semibold text-xs sm:text-sm tracking-wide">
                    Download Brochure
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;